import { useAuth } from "hooks/useAuth";

/**
 * Hook to know if the current items belongs to my group or to me (the user). Default scope is "group".
 * @param {Object} item - The item to check the ownership of.
 * @param {string} scope - The scope of the ownership check. Default is group, other means user.
 * @returns {boolean} True if the item belongs to my group or to me, false otherwise.
 */
const useItemOwner = (item, scope = "group") => {
  const { account, companyList } = useAuth();

  if (!item) return false;

  const itemOwner =
    scope === "group"
      ? companyList[0]?.id === item.groupId
      : account?.localAccountId === item.userId;

  return itemOwner;
};

export default useItemOwner;
